//import Cookies from 'js-cookie';
//import {navigate} from "hookrouter";
//import { returnToken, returnUserName } from './TokenUtil';

import { RestoreOutlined } from "@material-ui/icons";

export async function POSTRequest(strBody, url, token, setSubmitResult) {
    var body;
    let msgStatus = 0;
    const fetchData = async () => {
            const settings = {
                method: 'POST',
                changeOrigin: true,
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin' : '*',
                    'Authorization' : token,
                    'RequestedApplicationName': 'DPOOnlineRegistration'
                },
                body: strBody,             
            };

            const result = await fetch(process.env.REACT_APP_API_URL+url, settings).catch(error => {alert("Error");console.log(error);return 400;});            
            if(result.status === 401) {
              alert("Captcha validation failed!");
              return result.status;
            }
            else if(result.status !== 200)
            {
              alert("Something went wrong while saving the data!");
              return result.status;
            }    
            let body = await result.json();
            setSubmitResult(body);
 
            return 200;
        }
    msgStatus = await fetchData();
    return msgStatus;
}